import React from 'react';
import './index.css';

function NotFound() {
  return (
    <div className='notFound-container'>
        <h1>404 Not Found</h1>
        <h3>Al parecer esta página no existe 🤡💩</h3>
    </div>
  )
}

export default NotFound
